import { Slide } from '@/components/core/Slide';
import audioFile from './30-construction.mp3';

const autoNextDuration = 42000;
const transcript = `
  Laten we beginnen met bouwbedrijven.

  AI-ondersteunde bouwplanning kan helpen met het optimaliseren van planningen door weersvoorspellingen, 
  levertijden en personeelsbezetting te analyseren.

  Generatieve designsoftware kan automatisch bouwtekeningen genereren en optimaliseren voor 
  materiaalbesparing en efficiëntie.

  Slimme inspecties met computer vision maken het mogelijk om bouwplaatsen te scannen en risico's zoals 
  scheuren of onveilige situaties te detecteren.

  En AI kan bouwverslagen en rapportages automatisch samenvatten en structureren.

  De impact hiervan is significant: minder fouten, efficiënter plannen en lagere kosten.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-8">Bouwbedrijven 🏗️</h1>
        <ul className="space-y-4 list-disc">
          <li>AI-ondersteunde bouwplanning: Optimaliseren van planningen</li>
          <li>Generatieve designsoftware: Automatisch bouwtekeningen genereren</li>
          <li>Slimme inspecties met computer vision: Scannen van bouwplaatsen</li>
          <li>Automatische documentgeneratie: Bouwverslagen samenvatten</li>
        </ul>
      </div>
    </Slide>
  );
};
